import React from 'react';
import { Instagram, Facebook, MessageCircle } from 'lucide-react';
import { cn } from "@/lib/utils/cn";

interface PlatformSelectorProps {
  postToInstagram: boolean;
  setPostToInstagram: (val: boolean) => void;
  postToFacebook: boolean;
  setPostToFacebook: (val: boolean) => void;
  postToWhatsapp?: boolean;
  setPostToWhatsapp?: (val: boolean) => void;
  hasConnectedAccounts: boolean;
  hasWhatsappGroups?: boolean;
}

export const PlatformSelector: React.FC<PlatformSelectorProps> = ({
  postToInstagram,
  setPostToInstagram,
  postToFacebook,
  setPostToFacebook,
  postToWhatsapp,
  setPostToWhatsapp,
  hasConnectedAccounts,
  hasWhatsappGroups = false
}) => {
  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-gray-700">
        Plattformen
        <span className="ml-2 text-xs font-normal text-gray-500">(Mehrfachauswahl möglich)</span>
      </label>
      <div className={cn("grid gap-3", setPostToWhatsapp ? "grid-cols-3" : "grid-cols-2")}>
        <button
          type="button"
          onClick={() => setPostToInstagram(!postToInstagram)}
          disabled={!hasConnectedAccounts}
          className={cn(
            "flex flex-col items-center justify-center p-3 rounded-xl border-2 transition-all",
            postToInstagram 
              ? "border-pink-500 bg-pink-50 text-pink-700" 
              : "border-gray-200 hover:border-pink-200 hover:bg-pink-50 text-gray-600",
            !hasConnectedAccounts && "opacity-50 cursor-not-allowed"
          )}
        >
          <Instagram className="h-6 w-6 mb-2" />
          <span className="text-sm font-medium">Instagram</span>
        </button>
        <button
          type="button"
          onClick={() => setPostToFacebook(!postToFacebook)}
          disabled={!hasConnectedAccounts}
          className={cn(
            "flex flex-col items-center justify-center p-3 rounded-xl border-2 transition-all",
            postToFacebook 
              ? "border-blue-600 bg-blue-50 text-blue-700" 
              : "border-gray-200 hover:border-blue-200 hover:bg-blue-50 text-gray-600",
            !hasConnectedAccounts && "opacity-50 cursor-not-allowed"
          )}
        >
          <Facebook className="h-6 w-6 mb-2" />
          <span className="text-sm font-medium">Facebook</span>
        </button>
        {setPostToWhatsapp && (
          <button
            type="button"
            onClick={() => hasWhatsappGroups && setPostToWhatsapp(!postToWhatsapp)}
            disabled={!hasWhatsappGroups}
            className={cn(
              "flex flex-col items-center justify-center p-3 rounded-xl border-2 transition-all",
              postToWhatsapp 
                ? "border-green-600 bg-green-50 text-green-700" 
                : "border-gray-200 hover:border-green-200 hover:bg-green-50 text-gray-600",
              !hasWhatsappGroups && "opacity-50 cursor-not-allowed"
            )}
          >
            <MessageCircle className="h-6 w-6 mb-2" />
            <span className="text-sm font-medium">WhatsApp</span>
          </button>
        )}
      </div>
    </div>
  );
};
